<script>
export default {
  name: "CommonBottomBar",
  data(){
    return{

    }
  }
}
</script>

<template>
  <div class="item">
    <div class="hr"></div>
    <div class="span">{{$t('common.bottomBarText')}}</div>
    <div class="hr"></div>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.item{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15% 0;
  .hr{
    width: 7.8%;
    height: 3px;
    border: 1px solid #158800;
    background: #158800;
  }
  .span{
    text-align: center;
    width: 24%;
    padding: 0 41px;
    color: #158800;
    font-size: 25px;
    line-height: 32px;
    font-weight: bold;
  }
}
@include media-max(lg){
  .item{
    .span{
      padding: 0 15px;
      font-size: 20px;
      line-height: 32px;
    }
  }
}
@include media-max(md){
  .item{
    .span{
      width: 40%;
      font-size: 15px;
      line-height: 20px;
    }
  }
}
</style>